import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("g", { fill: "currentColor" }, [
      createElementVNode("path", { d: "M24 22.21 19.82 2a2.51 2.51 0 0 0-2.45-2H1.5A1.5 1.5 0 0 0 0 1.79l2.46 11.84a.24.24 0 0 1 0 .12L.06 22a1 1 0 0 0 1.94.56l1.07-3.69a.24.24 0 0 1 .25-.18.23.23 0 0 1 .23.2L4.18 22a2.51 2.51 0 0 0 2.45 2H22.5a1.5 1.5 0 0 0 1.5-1.79M3.72 4a.39.39 0 0 1 .4-.49h12.27A.63.63 0 0 1 17 4l3.29 16a.39.39 0 0 1-.4.49H7.61A.63.63 0 0 1 7 20Z" }),
      createElementVNode("path", { d: "M9 17h8a.51.51 0 0 0 .46-.71L15 10.79a.5.5 0 0 0-.89 0l-1.61 2.8a.22.22 0 0 1-.15.12.24.24 0 0 1-.2 0l-.83-.56a.51.51 0 0 0-.7.14l-2 3A.5.5 0 0 0 9 17m1-6.5A1.5 1.5 0 1 0 8.5 9a1.5 1.5 0 0 0 1.5 1.5" })
    ], -1)
  ]));
}
const imagePhotoFrame = { render };
export {
  imagePhotoFrame as default,
  render
};
//# sourceMappingURL=image-photo-frame.svg.js.map
